function normalizeEnumerationValue(value) {
  return value == null ? '' : String(value).trim();
}

function isEnumerationOptionsObject(enumeration) {
  return !!(
    enumeration &&
    typeof enumeration === 'object' &&
    !Array.isArray(enumeration)
  );
}

function isCompleteEnumerationOption(key, value) {
  return !!(
    normalizeEnumerationValue(key) &&
    normalizeEnumerationValue(value)
  );
}

function hasEnumerationOptions(enumeration) {
  if (!isEnumerationOptionsObject(enumeration)) return false;

  return Object.keys(enumeration).some(function (key) {
    return isCompleteEnumerationOption(key, enumeration[key]);
  });
}

hasEnumerationOptions.hasIncompleteOptions = function (enumeration) {
  if (!isEnumerationOptionsObject(enumeration)) return false;

  return Object.keys(enumeration).some(function (key) {
    return !isCompleteEnumerationOption(key, enumeration[key]);
  });
};

module.exports = hasEnumerationOptions;
